// export default VerifyGoogleSignIn;
import LoadingStrip from "@/components/ui/LoadinStrip";
import { VerifyToken } from "@/utils/verifyToken";
import { setUser } from "@/redux/feature/auth/authSlice";
import { useAppDispatch } from "@/redux/hooks/hooks";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { TUser } from "@/types/types";
import { apiClient } from "@/services/apiServices";
import { doRedirect, getRedirectParam } from "@/utils/redirectManager";

const VerifyUser = () => {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const client_dashboard_baseUrl =
    import.meta.env.VITE_NODE_ENV === "development"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_DEV
      : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_STAGE
      : import.meta.env.VITE_API_CLIENT_DASHBOARD_PROD;
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  // const [hasToastShown, setHasToastShown] = useState(false);
  const hasToastShown = useRef(false);
  const [hasProcessed, setHasProcessed] = useState(false);
  const redirect = getRedirectParam(location?.search);

  const accessToken = searchParams.get("t");
  const teamId = searchParams.get("teamId");
  console.log(accessToken);

  useEffect(() => {
    if (teamId) {
      localStorage.setItem("teamId", teamId);
    }

    if (!accessToken || hasProcessed) {
      if (!accessToken) {
        toast.error("Log In Failed");
      }
      setIsLoading(false);
      // navigate("/auth/sign-in");

      window.location.href = `${client_dashboard_baseUrl}/auth/sign-in?redirect=${redirect}`;
      return;
    }

    dispatch(setUser({ user: null, token: accessToken as string }));

    setHasProcessed(true);
    const timer = setTimeout(async () => {
      try {
        const user = VerifyToken(accessToken as string);

        dispatch(setUser({ user: user, token: accessToken as string }));

        // check if the user is onboarded or not
        // await handleCheckiftheUserOnboarded(user);
        const res = await apiClient.get(
          `/user/get-me?email=${encodeURIComponent((user as any)?.email)}`
        );
        const userDetail: TUser | undefined = res?.data?.data;
        if (userDetail?.onBoarded) {
          setIsLoading(false);

          console.log(redirect);
          doRedirect(redirect, navigate);
          return;
        } else {
          window.location.href = `${client_dashboard_baseUrl}/auth/sign-in?redirect=${redirect}`;
          // navigate("/onboarding");
          return;
        }

        // navigate("/");
      } catch (error) {
        toast.error("Invalid Access Token");

        window.location.href = `${client_dashboard_baseUrl}/auth/sign-in`;
        // navigate("/auth/sign-in");
      } finally {
        setIsLoading(false);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [accessToken]);
  const from = searchParams.get("from") || "/";

  const handleCheckiftheUserOnboarded = async (user: any) => {
    try {
      const res = await apiClient.get(`/user/get-me?email=${user.email}`);
      const userDetail: TUser | undefined = res?.data?.data;
      if (userDetail?.onBoarded) {
        return;
      } else {
        window.location.href = `${client_dashboard_baseUrl}/auth/sign-in?redirect=${redirect}`;
        // navigate("/onboarding");
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="h-screen flex justify-center items-center w-full">
      {isLoading ? (
        <div className="text-center w-[200px] space-y-2">
          {/* <p className="text-[16px] font-medium animate-pulse pb-2">
            Verifying...
          </p> */}
          <LoadingStrip />
        </div>
      ) : (
        <p className="text-[16px] font-semibold">Done</p>
      )}
    </div>
  );
};

export default VerifyUser;
